import { Button, Box, Typography, CircularProgress } from "@mui/material";

interface OnboardingStepProps {
  loading: boolean;
  onContinueOnboarding: () => Promise<void>;
}

const OnboardingStep = ({ loading, onContinueOnboarding }: OnboardingStepProps) => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2 }}>
      <Typography variant="body1">
        Continue with Stripe onboarding to set up your account.
      </Typography>
      {loading ? (
        <CircularProgress />
      ) : (
        <Button
          variant="contained"
          color="primary"
          onClick={onContinueOnboarding}
          disabled={loading}
          size="large">
          Continue Onboarding
        </Button>
      )}
    </Box>
  );
};

export default OnboardingStep; 